<template>
  <div class="content-with-sidebar">
    <div class="main-box">
      <slot name="main" />
    </div>
    <div class="sidebar-box">
      <slot name="sidebar" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentWithSidebar'
}
</script>

<!--suppress CssInvalidAtRule -->
<style lang="scss">
.content-with-sidebar {
  position: relative;
  display: block;
  /*flex-direction: column;*/
  /*justify-content: center;*/
  width: 100%;
  height: 100%;
  padding: var(--base-padding) 0;
  overflow-y: auto;

  &>* {
    position: relative;
    //padding-top: var(--base-size);
  }

  .main-box {
    flex-shrink: 1;
    flex-grow: 1;
    min-width: 0;

    .text-block {
      padding: 0 var(--base-padding);
      max-width: 100%;
      hyphens: auto;
    }
  }

  .sidebar-box {
    @apply px-base;
  }

  @media (min-width: calc(var(--max-width-text-block) + var(--max-width-sidebar) / 2)) {
    & {
      display: flex;
      flex-direction: row;

      .main-box {
        overflow-y: auto;
        //max-width: calc(var(--max-width-text-block) + var(--base-padding) * 2);
        padding: 0 calc(var(--base-padding) * 2);
        border-right: 1px solid var(--color-aba-blue);
      }

      .sidebar-box {
        overflow-y: auto;
        flex: 0 0 var(--max-width-sidebar);
        padding: var(--base-padding);
      }
    }
  }

  @media (min-width: calc(var(--max-width-text-block) + var(--max-width-sidebar) + var(--base-padding) * 3)) {
    .main-box .text-block {
      @apply px-0;
    }
  }
}
</style>
